import { LoggerFactory } from "../../../utilities/logger";
import { IClonable } from "..";
import { AbstractPropertyEditor } from "./AbstractPropertyEditor";

export class PropertyEditor<TSource, TValue> extends AbstractPropertyEditor<TSource, TValue> implements IClonable<PropertyEditor<TSource, TValue>> {
  constructor(source: { source: TSource, read: (s: TSource) => TValue, write: (v: TValue) => void, isWritable?: (s: TSource) => boolean } | PropertyEditor<TSource, TValue>) {
    super((source instanceof PropertyEditor) ? source : source.source);
    if (source instanceof PropertyEditor) {
      this._read = source._read;
      this._write = source._write;
      this._isWritable = source._isWritable;
    } else {
      this._read = source.read;
      this._write = source.write;
      this._isWritable = source.isWritable ? source.isWritable : (s => true);
    }
  }

  private readonly _read: (s: TSource) => TValue;
  private readonly _write: (v: TValue) => void;
  private readonly _isWritable: (s: TSource) => boolean;

  readValue(source: TSource): TValue {
    return this._read(source);
  }

  setValue(value: TValue): void {
    if (!this.isEditable()) {
      this._logger.warn("更新できません.");
      return;
    }
    this._write(value);
  }

  isEditable(): boolean {
    return this._isWritable(this._source);
  }

  clone(): PropertyEditor<TSource, TValue> {
    // TODO: 使い方的にcloneしない？しないならcloneのための諸実装は削除が望ましい.
    return new PropertyEditor(this);
  }

  private readonly _logger = LoggerFactory.getLogger();
}
